<template>
    <app-framework>
        <template v-slot:title>
            <tw-divider class="mb-3"
                        color="white"
                        width="56"
            ></tw-divider>
            Pricing
        </template>
        <row class="z-10">
            <column align="center" cols="full">
                <tw-divider class="mb-5"
                            color="primary"
                            width="56"
                ></tw-divider>
                <div
                    class="poppins-bold w-full text-center tracking-normal xs:text-3xl sm:text-5xl leading-higher mb-10">
                    Pricing
                </div>
                <card no-padding v-if="innerWidth > 839">
                    <table cellpadding="10" style="width: 100%;">
                        <thead>
                        <tr>
                            <th></th>
                            <th :key="index" v-for="(heading, index) in pricingData.headings" valign="top">
                                <div class="flex flex-col items-center justify-start">
                                    <div class="bg-primary poppins-bold uppercase px-4 py-3 rounded-full text-white"
                                         style="width: 140px;">
                                        {{ heading.title }}
                                    </div>
                                    <div class="poppins-bold mt-6"
                                         v-if="heading.price && heading.unit && heading.application">
                                        {{ heading.price }} {{ heading.unit }} {{ heading.application }}
                                    </div>
                                </div>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr :class="innerWidth < 850 ? 'overflow-x-auto' : ''" :key="index"
                            class="odd:bg-primary odd:bg-opacity-5 relative"
                            v-for="(item, index) in pricingData.items"
                        >
                            <td>{{ item.text }}</td>
                            <td align="center">
                                <icon color="primary" icon="check-all"
                                      v-if="item.applicable_on.base === 'supported'">

                                </icon>
                                <icon color="#a0aec0" icon="circle-medium"
                                      v-else-if="item.applicable_on.base === 'other'">

                                </icon>
                                <div class="text-gray-500" v-else-if="item.applicable_on.base === 'not_supported'">-
                                </div>
                                <div class="text-gray-500" v-else-if="item.applicable_on.base === 'semi_supported'">=
                                </div>
                            </td>
                            <td align="center">
                                <icon color="primary" icon="check-all"
                                      v-if="item.applicable_on.premium === 'supported'"></icon>
                                <icon color="#a0aec0" icon="circle-medium"
                                      v-else-if="item.applicable_on.premium === 'other'"></icon>
                                <div class="text-gray-500" v-else-if="item.applicable_on.premium === 'not_supported'">
                                    -
                                </div>
                                <div class="text-gray-500" v-else-if="item.applicable_on.premium === 'semi_supported'">
                                    =
                                </div>
                            </td>
                            <td align="center">
                                <icon color="primary" icon="check-all"
                                      v-if="item.applicable_on.executive === 'supported'"></icon>
                                <icon color="#a0aec0" icon="circle-medium"
                                      v-else-if="item.applicable_on.executive === 'other'"></icon>
                                <div class="text-gray-500" v-else-if="item.applicable_on.executive === 'not_supported'">
                                    -
                                </div>
                                <div class="text-gray-500"
                                     v-else-if="item.applicable_on.executive === 'semi_supported'">=
                                </div>
                            </td>
                            <td class="bg-white" rowspan="0" v-if="index === 0">
                                <div class="poppins-bold text-primary text-center" style="max-width: 170px;">
                                    Contact
                                    Us For Enterprise
                                    Options. Which Include The
                                    Following Benefits:
                                </div>
                                <div class="text-center" style="max-width: 170px;">
                                    Projects Discount
                                    <br>
                                    Calculator
                                    <br>
                                    Api Integrations
                                    <br>
                                    Flexible Payment Plans
                                    <br>
                                    A Dedicated Senior
                                    <br>
                                    Account Manager
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </card>
                <row v-else>
                    <column align="center" cols="full">
                        <card :key="index"
                              class="mb-5"
                              no-padding style="max-width: 500px;"
                              v-for="(heading, index) in pricingData.headings.slice(0,3)"
                        >
                            <row class="p-3 bg-primary text-white" justify="center">
                                <div class="poppins-bold w-full text-center uppercase">
                                    {{ heading.title }}
                                </div>
                                <div class="poppins-bold">
                                    {{ heading.price }} {{ heading.unit }} {{ heading.application }}
                                </div>
                            </row>
                            <row :key="index"
                                 align="stretch"
                                 class="odd:bg-primary odd:bg-opacity-5 p-3"
                                 v-for="(item, index) in pricingData.items"
                            >
                                <column align="center" class="" cols="2/3">
                                    <div class="w-full">
                                        <div>
                                            {{ item.text }}
                                        </div>
                                    </div>
                                </column>
                                <column align="center" cols="1/3" justify="center">
                                    <icon color="primary" icon="check-all"
                                          v-if="item.applicable_on[heading.title] === 'supported'">

                                    </icon>
                                    <icon color="#a0aec0" icon="circle-medium"
                                          v-else-if="item.applicable_on[heading.title] === 'other'">

                                    </icon>
                                    <div class="text-gray-500"
                                         v-else-if="item.applicable_on[heading.title] === 'not_supported'">-
                                    </div>
                                    <div class="text-gray-500"
                                         v-else-if="item.applicable_on[heading.title] === 'semi_supported'">=
                                    </div>
                                </column>
                            </row>
                        </card>
                    </column>
                </row>
                <card class="mb-5"
                      no-padding
                      style="max-width: 500px;"
                      v-if="innerWidth < 850"
                >
                    <row class="p-3 bg-secondary text-white uppercase" justify="center">
                        <div class="poppins-bold w-full text-center">
                            {{ pricingData.headings[3].title }}
                        </div>
                    </row>
                    <column align="center"
                            class="p-3"
                            cols="full"
                    >
                        <div class="poppins-bold text-primary text-center mb-5">
                            Contact
                            Us For Enterprise
                            Options.
                            <br>
                            Which Include The
                            Following Benefits:
                        </div>
                        <div class="text-center">
                            Projects Discount
                            <br>
                            Calculator
                            <br>
                            Api Integrations
                            <br>
                            Flexible Payment Plans
                            <br>
                            A Dedicated Senior
                            <br>
                            Account Manager
                        </div>
                    </column>
                </card>
                <div :class="innerWidth > 839 ? 'justify-start' : 'justify-center'"
                     class="text-info w-full flex flex-row">
                    <span>*Delivered in person or virtually Prices</span>
                    <span class="mx-6">virtually Prices are net of any applicable</span>
                    <span>tax O = Optional</span>
                </div>
            </column>
            <column align="center" class="mt-20" cols="full">
                <tw-divider class="mb-5"
                            color="primary"
                            width="56"
                ></tw-divider>
                <div
                    class="poppins-bold w-full text-center tracking-normal xs:text-3xl sm:text-5xl leading-higher mb-10">
                    fitt Enterprise Option
                </div>
                <row>
                    <column :key="index"
                            class="mb-8 p-2" lg="1/3" md="1/3"
                            sm="full"
                            v-for="(option, index) in enterpriseOptions" xl="1/3"
                            xs="full"
                    >
                        <row align="center" no-wrap>
                            <card
                                class="flex justify-center items-center"
                                round style="min-width: 71px; max-width: 71px; min-height: 71px; max-height: 71px;"
                            >
                                <icon :icon="option.icon" color="primary"></icon>
                            </card>
                            <div class="ml-6 text-md tracking-normal xs:leading-snug sm:leading-relaxed">
                                {{ option.text }}
                            </div>
                        </row>
                    </column>
                </row>
            </column>
            <column align="center" class="mt-20" cols="full">
                <tw-divider class="mb-5"
                            color="primary"
                            width="56"
                ></tw-divider>
                <div
                    class="poppins-bold w-full text-center tracking-normal xs:text-3xl sm:text-5xl leading-higher mb-10">
                    Add Value Products
                </div>
                <card no-padding>
                    <table cellpadding="25">
                        <thead>
                        <tr class="bg-primary">
                            <th :key="index" align="left"
                                class="text-white uppercase poppins-bold"
                                v-for="(heading, index) in valueProducts.headings">
                                {{ heading }}
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr :key="index" class="odd:bg-primary odd:bg-opacity-5"
                            v-for="(item, index) in valueProducts.items">
                            <td class="poppins-bold">{{ item.product }}</td>
                            <td>{{ item.description }}</td>
                            <td>{{ item.method }}</td>
                            <td>{{ item.price }}</td>
                        </tr>
                        </tbody>
                    </table>
                </card>
            </column>
            <column class="my-20" cols="full">
                <row class="xs:mb-16 sm:mb-16">
                    <column class="items-center" md="1/2" sm="full" xs="full">
                        <img :src="requireSrc('fitt_dark_clear_cropped.png')"
                             alt="fitt_dark_clear_cropped"
                             class="h-32 xs:mb-10 sm:mb-20"
                        >
                    </column>
                    <column class="items-center" md="1/2" sm="full" xs="full">
                        <img :src="requireSrc('cambridge_logo.png')"
                             alt="fitt_dark_clear_cropped"
                             class="h-32"
                        >
                    </column>
                </row>
                <div class="w-full text-center xs:text-xl sm:text-xl md:text-2xl">
                    The University of Cambridge Psychometrics Centre is the official validation partner for fitt
                </div>
            </column>
        </row>
    </app-framework>
</template>

<script>
    import Helpers from "../mixins/Helpers";

    export default {
        name: "Pricing",
        mixins: [Helpers],
        components: {
            'app-framework': () => import('@/components/layout/AppFramework.vue'),
            'tw-divider': () => import('@/components/Divider.vue'),
            card: () => import('@/components/Card.vue'),
            icon: () => import('@/components/display/Icon.vue'),
        },
        data: () => ({
            innerWidth: 0,
            pricingData: {
                headings: [
                    {
                        title: 'base',
                        price: '390',
                        unit: 'USD',
                        application: 'p/user'
                    },
                    {
                        title: 'premium',
                        price: '480',
                        unit: 'USD',
                        application: 'p/user'
                    },
                    {
                        title: 'executive',
                        price: '2,950.00',
                        unit: 'USD',
                        application: 'p/user'
                    },
                    {
                        title: 'enterprise',
                        price: null,
                        unit: null,
                        application: null
                    }
                ],
                items: [
                    {
                        text: 'Full fitt journey',
                        applicable_on: {
                            base: 'supported',
                            premium: 'supported',
                            executive: 'supported'
                        }
                    },
                    {
                        text: 'ASYNCHRONOUS SIMULATIONS AND EXERCISES',
                        applicable_on: {
                            base: 'supported',
                            premium: 'supported',
                            executive: 'supported'
                        }
                    },
                    {
                        text: 'Industrial Psychologist Input',
                        applicable_on: {
                            base: 'supported',
                            premium: 'supported',
                            executive: 'supported'
                        }
                    },
                    {
                        text: 'Individual and Group Based Reporting (PDF)',
                        applicable_on: {
                            base: 'supported',
                            premium: 'supported',
                            executive: 'supported'
                        }
                    },
                    {
                        text: 'Data downloads (Excel)',
                        applicable_on: {
                            base: 'supported',
                            premium: 'supported',
                            executive: 'supported'
                        }
                    },
                    {
                        text: 'Projects Administration',
                        applicable_on: {
                            base: 'supported',
                            premium: 'supported',
                            executive: 'supported'
                        }
                    },
                    {
                        text: 'University of Cambridge fitt Validation and Completion Certificates',
                        applicable_on: {
                            base: 'supported',
                            premium: 'supported',
                            executive: 'supported'
                        }
                    },
                    {
                        text: 'Digital Reporting Tools',
                        applicable_on: {
                            base: 'not_supported',
                            premium: 'supported',
                            executive: 'supported'
                        }
                    },
                    {
                        text: 'Customized Branding',
                        applicable_on: {
                            base: 'not_supported',
                            premium: 'supported',
                            executive: 'supported'
                        }
                    },
                    {
                        text: 'Tailored Employee Development Plans',
                        applicable_on: {
                            base: 'not_supported',
                            premium: 'supported',
                            executive: 'supported'
                        }
                    },
                    {
                        text: 'Customized Competence Profiles',
                        applicable_on: {
                            base: 'not_supported',
                            premium: 'supported',
                            executive: 'supported'
                        }
                    },
                    {
                        text: 'Organizational Tailored synchronous group talent development exercises',
                        applicable_on: {
                            base: 'semi_supported',
                            premium: 'not_supported',
                            executive: 'supported'
                        }
                    },
                    {
                        text: 'Organizational Tailored synchronous group case studies/simulations',
                        applicable_on: {
                            base: 'not_supported',
                            premium: 'not_supported',
                            executive: 'supported'
                        }
                    },
                    {
                        text: 'Multiple Industrial Psychologist ratings input',
                        applicable_on: {
                            base: 'not_supported',
                            premium: 'not_supported',
                            executive: 'supported'
                        }
                    },
                    {
                        text: 'Individual Career Coaching Feedback Session',
                        applicable_on: {
                            base: 'other',
                            premium: 'other',
                            executive: 'supported'
                        }
                    },
                    {
                        text: 'myFitt Mobile Content Application',
                        applicable_on: {
                            base: 'not_supported',
                            premium: 'not_supported',
                            executive: 'supported'
                        }
                    }
                ]
            },
            enterpriseOptions: [
                {
                    text: 'Designed for projects of 500+ fitt profiles',
                    icon: 'account-supervisor'
                },
                {
                    text: 'Receive a tailored discount benefit offer through our enterprise calculator',
                    icon: 'poll'
                },
                {
                    text: 'Applicable to Premium and Executive packages',
                    icon: 'star-outline'
                },
                {
                    text: 'Inclusive of 15 complimentary fitt accreditation courses',
                    icon: 'school-outline'
                },
                {
                    text: 'Flexible payment plan tailored to organizational needs',
                    icon: 'credit-card-outline'
                },
                {
                    text: 'Includes all fitt feautures + API Integration + dedicated senior account manager',
                    icon: 'cog-outline'
                },
            ],
            valueProducts: {
                headings: ['product', 'description', 'method', 'price(usd)'],
                items: [
                    {
                        product: 'fitt Accreditation Training',
                        description: 'Accreditation Training to subject matter experts in fitt methodology, report interpretation and feedback',
                        method: 'Per delegate',
                        price: '2150.00'
                    },
                    {
                        product: 'Additional Coaching',
                        description: 'Individual candidate coaching for fitt feedback, career planning and development. Led by Industrial Psychologist/accredited fitt coach. 60 minute session',
                        method: 'Per session',
                        price: '220.00'
                    },
                    {
                        product: 'fitt Succession TIQ',
                        description: 'Tailored and bespoke succession planning software for hosting fitt data, HRlS integration and user features for talent reviews',
                        method: 'Scoped on need',
                        price: 'Based on project scope'
                    },
                    {
                        product: 'Customized platform, content and simulations',
                        description: 'Bespoke and tailored content development, digital assets and additional required simulations, exercises and/ or case studies',
                        method: 'Scoped on need',
                        price: 'Based on project scope'
                    },
                    {
                        product: 'Ad Hoc Needs Consulting',
                        description: 'Ad hoc consulting needs as per client requirements',
                        method: 'Scoped on need',
                        price: 'Based on project scope'
                    },
                ]
            }
        }),
        methods: {
            requireSrc(src) {
                return require('@/assets/logos/' + src);
            },
            setInnerWidth() {
                this.innerWidth = innerWidth;
            }
        },
        mounted() {
            window.addEventListener('resize', this.debounce(this.setInnerWidth, 500));
            this.setInnerWidth();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setInnerWidth);
        }
    }
</script>

<style scoped>

</style>